import { useRef } from "react";
import { useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";
import toast from "react-hot-toast";
import styles from "./invoice.module.css";
import {
  Button,
  HeadingTitle,
  Image,
  Loader,
  SubHeadingTitle,
} from "../../../components/shared/index";
import { useGetOrderInvoiceQuery } from "../../../queries/useOrderQuery";
const InvoiceOrder = () => {
  const { invoiceNumber } = useParams();
  const invoiceRef = useRef(null);
  const { data, isPending, error } = useGetOrderInvoiceQuery(invoiceNumber);
  if (isPending)
    return (
      <div className={styles.loaderWrapper}>
        <Loader title="Loading Invoice..." />
      </div>
    );
  if (error) return <p>Failed to load invoice</p>;
  if (!data) return <p>No invoice found</p>;
  const order = data;
  const billing = order?.order_address || {};
  const products = order?.order_products || [];
  const shippingCost = order?.shipping_method?.cost || 0;
const handleDownload = async () => {
  if (!invoiceRef.current) return;

  const element = invoiceRef.current;

  const options = {
    margin: 0,
    filename: `Invoice-${order?.invoice_id || invoiceNumber}.pdf`,
    image: {
      type: "jpeg",
      quality: 0.98,
    },
    html2canvas: {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait",
    },
    pagebreak: {
      mode: ["avoid-all", "css", "legacy"],
    },
  };

  try {
    await html2pdf()
      .set(options)
      .from(element)
      .save();
  } catch (error) {
    console.error("Invoice PDF download error:", error);
    toast.error("Failed to download invoice");
  }
};
  return (
    <section className={styles.invoiceWrapper}>
      <div className={styles.downloadBtnWrapper}>
        <Button
          title="Download Invoice"
          onHandler={handleDownload}
          style={styles.downloadBtn}
        />
      </div>
    <div
  ref={invoiceRef}
  className={styles.invoiceCard}
>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
             <img
  src="/vitauralogo.jpg"
  alt="Vitaura Logo"
  style={{
    width: "220px",
    height: "80px",
    objectFit: "contain",
    display: "block",
   marginLeft:"-2rem"
   
  }}
/>
            <HeadingTitle text="INVOICE" style={styles.invoiceTitle} /> 
            <SubHeadingTitle
              subTitle={`Invoice ID: ${order?.invoice_id}`}
              style={styles.metaText}
            />  
          
            <SubHeadingTitle
              subTitle={`Status: ${order?.order_status}`}
              style={styles.metaText}
            />
            <SubHeadingTitle
              subTitle={`Date: ${new Date(
                order?.created_at
              ).toLocaleDateString()}`}
              style={styles.metaText}
            />
          </div>
          <div className={styles.fromAddress}>
            <p>From:</p>
            <p>Vitaura Life Sciences</p>
            <p>Kompally , Hyderabad</p>
            <p>info@vitaura.co.in</p>
            <p>+91 8019070584</p>
          </div>
        </div>
        <div className={styles.infoGrid}>
          <div>
            <HeadingTitle text="Bill To:" style={styles.sectionTitle} />
            <SubHeadingTitle
              subTitle={billing?.name || "-"}
              style={styles.metaText}
            />
            <SubHeadingTitle
              subTitle={billing?.email || "-"}
              style={styles.metaText}
            />
            <SubHeadingTitle
              subTitle={billing?.phone || "-"}
              style={styles.metaText}
            />
            <SubHeadingTitle
              subTitle={billing?.address || "-"}
              style={styles.metaText}
            />
            <SubHeadingTitle
              subTitle={`${billing?.city || "-"}, ${billing?.zip || "-"}`}
              style={styles.metaText}
            />
          </div>
          <div>
            <HeadingTitle text="Ship To:" style={styles.sectionTitle} />
            <p>{billing?.name || "-"}</p>
            <p>{billing?.address || "-"}</p>
            <p>
              {billing?.city || "-"}, {billing?.zip || "-"}
            </p>
            <p>{billing?.phone || "-"}</p>
          </div>
        </div>
        <div className={styles.tableWrapper}>
          <table className={styles.invoiceTable}>
            <thead>
              <tr>
                <th>PRODUCT</th> 
              
                <th>UNIT PRICE</th>
                  {/* <th>SKU</th>  */}
                <th>QTY</th>
                <th>TOTAL</th> 
              </tr>
            </thead>
         <tbody>
  {products?.map((item) => {
    const price = Number(item?.product?.price || item?.unit_price || 0);

    const offer =
      item?.product?.offer_price !== null &&
      item?.product?.offer_price !== undefined &&
      item?.product?.offer_price !== ""
        ? Number(item?.product?.offer_price)
        : null;

    const hasOffer = offer !== null && offer < price;

    const finalPrice = hasOffer ? offer : price;

    return (
      <tr key={item?.id}>
      <td>
  <div className={styles.productInfo}>
    <div className={styles.productName}>
      {item?.product_name}
    </div>

    <div className={styles.productSku}>
      SKU: {item?.product?.sku || "-"}
    </div>
  </div>
</td>

        {/* UNIT PRICE */}
     <td className={styles.priceCell}>
  <div className={styles.unitPriceBox}>
    
    <div className={styles.finalPrice}>
      ₹ {finalPrice}
    </div>

    {hasOffer && (
      <div className={styles.offerRow}>
        <span className={styles.originalPrice}>
          ₹ {price}
        </span>

        <span className={styles.discountText}>
          {Math.round(((price - offer) / price) * 100)}% OFF
        </span>
      </div>
    )}
    
  </div>
</td>

        {/* SKU */}
        {/* <td>
          {item?.product?.sku || "-"}
        </td> */}

        {/* QTY */}
        <td>{item?.qty}</td>

        {/* TOTAL */}
        <td className={styles.priceCell}>
          ₹ {finalPrice * item?.qty}
        </td>
      </tr>
    );
  })}
</tbody>
          </table>
        </div>
        <div className={styles.bottomSection}>
          <div>
            {/* <p>Order Status: {order?.order_status}</p>
            <p>Payment Status: {order?.payment_status}</p> */}
          </div>
          <div className={styles.summary}>
            <div className={styles.summaryRow}>
              <span>Subtotal:</span>
              <span>₹ {order?.sub_total}</span>
            </div>
             <div className={styles.summaryRow}>
              <span>GST (0%) :</span>
              <span>₹ 0</span>
            </div>
            <div className={styles.summaryRow}>
              <span>Shipping:</span>
              <span>₹ {shippingCost}</span>
            </div>
            <div className={styles.summaryRow}>
              <span>Payment Method:</span>
              <span>{order?.payment_method.toUpperCase()}</span>
            </div>
            <div className={`${styles.summaryRow} ${styles.grandTotal}`}>
              <span>Grand Total:</span>
              <span>₹ {order?.amount}</span>
            </div>
          </div>
        </div>
        <p className={styles.footerNote}>
          Thank you for shopping with us! <br />
          For support: info@vitaura.co.in
        </p>
      </div>
    </section>
  );
};
export default InvoiceOrder;